import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ReactComponent as CheckIcon } from '../../../../assets/icons/check_purple_icon.svg';
import { useNavigate } from 'react-router-dom';
import { Spin } from 'antd';

const ActionList = props => {
  //const view = useSelector(state => state.appTrack.permissions.view)
  const [isReady, setIsReady] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const view = useSelector(state => state.appTrack.permissions.view);
  const edit = useSelector(state => state.appTrack.permissions.edit);
  const cancel = useSelector(state => state.appTrack.permissions.cancel);

  useEffect(() => {
    if (props?.id) {
      setIsReady(true);
    }
  }, [dispatch, props.id, view, edit, cancel]);

  // Error state
  if (error) {
    return (
      <div className="popover-container">
        <div className="popover-item" style={{ color: 'red', padding: '12px' }}>
          Failed to load actions
        </div>
      </div>
    );
  }

  // loading state ...
  if (!isReady) {
    return (
      <div id={`action-list-for-${props.id}`} className="popover-container">
        <div
          className="popover-item"
          style={{ textAlign: 'center', padding: '12px' }}
        >
          <Spin size="small" />
        </div>
      </div>
    );
  }

  const onEditInterestApplication = (id, view) => {
    view
      ? navigate(`/fundingadminpage/${id}/view`)
      : navigate(`/fundingadminpage/${id}`);
  };

  return (
    <div id={`action-list-for-${props.id}`} className={'popover-container'}>
      {
        <div
          id="action-button-edit"
          className="popover-item"
          onClick={() => onEditInterestApplication(props.id, true)}
        >
          Προβολή <CheckIcon className="check" />
        </div>
      }
      {props.status === 'PENDING' ? (
        <div
          id="action-button-edit"
          className="popover-item"
          onClick={() => onEditInterestApplication(props.id, false)}
        >
          Επεξεργασία
          <CheckIcon className="check" />
        </div>
      ) : null}
    </div>
  );
};

export default ActionList;
